module.exports = __webpack_public_path__ + "static/media/vehicle9.1d77a563.svg";